import script from "./orderMseeage.vue?vue&type=script&lang=ts&setup=true"
export * from "./orderMseeage.vue?vue&type=script&lang=ts&setup=true"

import "./orderMseeage.vue?vue&type=style&index=0&id=fb2185e0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb2185e0"]])

export default __exports__